import type { BaseLocationEvent } from '../../../domain/models/locations/BaseLocationEvent';
import { Calendar, Gift, Leader, Map as MapIcon } from '@peacecover/icon';
import dDayCalculate from '@pocapan/shared/utils/dDayCalculate';
import { useNavigate } from 'react-router-dom';
import { useQueryParams } from '@pocapan/shared/utils/useQueryParams';
import { getLocationEventEmoji, processedGoodsNames } from '@pocapan/shared/utils/EventUtils';
import { t } from 'i18next';

interface EventReportBoxProps {
  event: BaseLocationEvent;
}

const EventReportBox: React.FC<EventReportBoxProps> = ({ event }) => {
  const navigate = useNavigate();
  const { queryParams } = useQueryParams();
  const locationName = queryParams.get('locationName');

  const handleClick = () => {
    navigate(
      `/report-location/events/already-reported?${queryParams.toString()}&eventId=${event.eventId}&locationId=${event.locationId}`,
      { state: { event } }
    );
  };

  return (
    <button
      className="flex w-[327px] bg-background-light dark:bg-background-dark dark:border dark:border-separator2 rounded-[20px] p-[16px] shadow-[0_0_0_1px_rgba(0,0,0,0.01),0_0_14px_0_rgba(0,0,0,0.08)] gap-[14px] dark:shadow-[0_0_1px_1px_rgba(0,0,0,0.70),0_0_14.9px_0_rgba(0,0,0,0.70)]"
      onClick={handleClick}
      type="button"
    >
      <img
        src={event.baseImageUrl}
        alt="event"
        className="w-[79px] h-[110px] rounded-[12px] object-cover"
      />
      <div className="flex flex-col gap-[10px] justify-center my-auto">
        <div className="flex items-start justify-between">
          <div className="font-semibold text-[16px] leading-[20px] text-text-main-lv1 line-clamp-2 mb-[4px] whitespace-pre-wrap">
            <span className="align-middle">{event.name}</span>
            <span className="text-[10px] px-[4px] py-[2px] rounded-[4px] bg-secondary-light dark:bg-secondary-dark text-on-secondary leading-none ml-[2px] align-middle inline-block">
              {dDayCalculate(event.startDate.toString(), event.endDate.toString())}
            </span>
          </div>
        </div>
        <div className="flex flex-col items-start gap-[6px]">
          <div className="text-[13px] leading-none text-text-main-lv4 flex items-center gap-[4px]">
            <img
              src={getLocationEventEmoji(event.category)}
              alt="birthday-cafe"
              className="w-[14px] h-[14px]"
            />
            {t(`SpotsCategory.${event.category}.value`)} ·{' '}
            <Leader size={14} className="text-text-sub-lv1" /> {event.organizerTwitterId}
          </div>

          <div className="flex items-center gap-[6px] leading-none">
            <Calendar size={14} className="text-text-sub-lv1" />
            <span className="text-[13px] text-text-main-lv4">
              {event.startDate.toLocaleDateString()} ~ {event.endDate.toLocaleDateString()}
            </span>
          </div>

          {event.goodsNames && (
            <div className="flex items-center gap-[6px] leading-none">
              <Gift size={14} className="text-text-sub-lv1" />
              <span className="text-[13px] text-text-main-lv4">
                {processedGoodsNames(event.goodsNames)}
              </span>
            </div>
          )}
          {event.category !== 'birthday_cafe' && (
            <div className="flex items-center gap-[6px] leading-none">
              <MapIcon size={14} className="text-text-sub-lv1" />
              <span className="text-[13px] text-text-main-lv4">{locationName}</span>
            </div>
          )}
        </div>
      </div>
    </button>
  );
};
export default EventReportBox;
